<template>
  <table-component-buefy
    v-if="mixin.loaded"
    :hide_table_search="true"
    :content="cardOrders"
    :headings="headings"
    :item_keys="item_keys"
    :display_spec="cardOrderSpecs"
    :total_items="mixin.total_items"
    :pagination_callback="mixin.loadItems"
    :col_styles="col_styles">
  </table-component-buefy>
  <loader-component v-else></loader-component>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  import TableComponentBuefy from '@/components/layout/table/TableComponentBuefy'
  import { cardOrderSpecs } from '@/display_context/display_context'
  import { loadItemsMixin, setContainedHeightMixin } from '@/mixins/mixins'
  import LoaderComponent from '@/components/layout/utility/LoaderComponent'

  export default {
    name: 'customer-card-orders-view',
    mixins: [loadItemsMixin, setContainedHeightMixin],
    data () {
      return {
        headings: ['Certificate number', 'Certificate service', 'Status', 'Source', 'Created'],
        item_keys: ['certificate.certificateNumber', 'certificate.service.name', 'status', 'source.display', 'created'],
        col_styles: {},
        cardOrderSpecs: cardOrderSpecs,
        mixin: {
          actionMethod: this.getCardOrders,
          actionParams: { customer: this.customerId }
        }
      }
    },
    props: {
      customerId: {
        required: true
      }
    },
    components: {
      TableComponentBuefy,
      LoaderComponent
    },
    computed: {
      ...mapState({
        cardOrders: state => state.cardOrderModule.cardOrders
      })
    },
    methods: {
      ...mapActions([
        'getCardOrders'
      ])
    }
  }
</script>
